import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
// components
// store
import { fetchUserInfo, callGetApiKeys, callGetPlans, callGetAddOns, callGetCurrentSubscription, callGetUsageBlockOptions, } from "module/main/store/auth/thunk";
import { useAppDispatch } from "module/main/store/hooks";
import { selectIsAuthenticated } from "module/main/store/auth/selectors";
var useDataLoad = function () {
    var dispatch = useAppDispatch();
    var isAuthenticated = useSelector(selectIsAuthenticated);
    var _a = useState(true), hasLoaded = _a[0], setHasLoaded = _a[1];
    useEffect(function () {
        if (isAuthenticated) {
            setHasLoaded(false);
            Promise.allSettled([
                dispatch(fetchUserInfo()),
                dispatch(callGetApiKeys()),
                dispatch(callGetPlans()),
                dispatch(callGetAddOns()),
                dispatch(callGetUsageBlockOptions()),
                dispatch(callGetCurrentSubscription()),
            ]).finally(function () { return void setHasLoaded(true); });
        }
    }, [isAuthenticated]);
    return hasLoaded;
};
export default useDataLoad;
